import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = (process.env.REACT_APP_API_BASE || '').replace(/\/api$/, '') || (window.location.protocol === 'https:' ? '' : `http://${window.location.hostname}:5000`);

const PREBUILT = [
  {
    name: 'appointment_reminder',
    category: 'utility',
    body: 'Namaste {{1}}, reminder: aapka appointment {{2}} ko {{3}} baje hai. Dr. ke clinic par milte hain. — Team ORALZY',
    vars: ['Patient name', 'Date', 'Time']
  },
  {
    name: 'treatment_followup',
    category: 'utility',
    body: 'Hello {{1}}, {{2}} treatment ke baad aap kaise feel kar rahe hain? Koi dikkat ho to reply karein.',
    vars: ['Patient name', 'Treatment']
  },
  {
    name: 'payment_reminder',
    category: 'utility',
    body: 'Dear {{1}}, ₹{{2}} outstanding hai. Kripya jaldi payment karein. Thanks!',
    vars: ['Patient name', 'Amount']
  },
  {
    name: 'festival_offer',
    category: 'marketing',
    body: '🎉 {{1}} Special! Free consultation + 20% off cleaning. Book: {{2}}. Valid till {{3}}.',
    vars: ['Festival', 'Link', 'Date']
  },
  {
    name: 'checkup_reminder_6m',
    category: 'utility',
    body: 'Hi {{1}}, 6 months ho gaye aapki last visit ko. Free check-up ke liye book karein!',
    vars: ['Patient name']
  },
  {
    name: 'welcome_new_patient',
    category: 'utility',
    body: 'Welcome {{1}}! Thanks for choosing our clinic. Aapke sare records safe hain. Questions? Reply karein.',
    vars: ['Patient name']
  }
];

export default function WhatsAppTemplatesPage() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [showPrebuilt, setShowPrebuilt] = useState(false);
  const [form, setForm] = useState({ name: '', category: 'utility', language: 'en', body: '' });

  const token = localStorage.getItem('dentalToken');
  const headers = { Authorization: `Bearer ${token}` };

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/api/saas/wa-templates`, { headers });
      setTemplates(data || []);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const create = async (tmpl) => {
    const t = tmpl || form;
    if (!t.name || !t.body) return alert('Name + body required');
    try {
      await axios.post(`${API}/api/saas/wa-templates`, {
        name: t.name.toLowerCase().replace(/\s+/g, '_'),
        category: t.category,
        language: t.language || 'en',
        components: [{ type: 'BODY', text: t.body }]
      }, { headers });
      setForm({ name: '', category: 'utility', language: 'en', body: '' });
      setShowCreate(false);
      setShowPrebuilt(false);
      load();
    } catch (err) { alert('Failed to create template'); }
  };

  const statusBadge = (s) => {
    const colors = { draft: '#f59e0b', pending: '#3b82f6', approved: '#10b981', rejected: '#ef4444' };
    return <span style={{ background: colors[s] || '#888', color: 'white', padding: '2px 8px', borderRadius: 12, fontSize: 11 }}>{s}</span>;
  };

  return (
    <div style={{ padding: 24, maxWidth: 1200, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ margin: 0 }}>📝 WhatsApp Templates</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={() => setShowPrebuilt(true)} style={btnSecondary}>📚 Pre-built Library</button>
          <button onClick={() => setShowCreate(true)} style={btnPrimary}>+ New Template</button>
        </div>
      </div>

      <div style={{ background: '#fef3c7', padding: 12, borderRadius: 6, marginBottom: 16, fontSize: 13 }}>
        ℹ️ Meta approval required before using templates for broadcasts. Use <code>{'{{1}}'}</code>, <code>{'{{2}}'}</code> for variables.
      </div>

      {loading ? <div>Loading...</div> : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16 }}>
          {templates.map(t => (
            <div key={t._id} style={card}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                <strong>{t.name}</strong>
                {statusBadge(t.status)}
              </div>
              <div style={{ fontSize: 12, color: '#666', marginBottom: 8 }}>
                {t.category} · {t.language}
              </div>
              <div style={{ background: '#f9fafb', padding: 10, borderRadius: 4, fontSize: 13, whiteSpace: 'pre-wrap' }}>
                {t.components?.[0]?.text || '(empty)'}
              </div>
            </div>
          ))}
          {templates.length === 0 && (
            <div style={{ color: '#888', padding: 40, textAlign: 'center', gridColumn: '1/-1' }}>
              No templates yet. Start from pre-built library or create new.
            </div>
          )}
        </div>
      )}

      {showCreate && (
        <Modal onClose={() => setShowCreate(false)} title="New Template">
          <input placeholder="Template name (lowercase_underscore)" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} style={input} />
          <select value={form.category} onChange={e => setForm({ ...form, category: e.target.value })} style={input}>
            <option value="utility">Utility</option>
            <option value="marketing">Marketing</option>
            <option value="authentication">Authentication</option>
          </select>
          <select value={form.language} onChange={e => setForm({ ...form, language: e.target.value })} style={input}>
            <option value="en">English</option>
            <option value="hi">Hindi</option>
            <option value="en_US">English (US)</option>
          </select>
          <textarea
            placeholder="Body text. Use {{1}}, {{2}} for variables."
            value={form.body}
            onChange={e => setForm({ ...form, body: e.target.value })}
            style={{ ...input, minHeight: 120 }}
          />
          <button onClick={() => create()} style={btnPrimary}>Save as Draft</button>
        </Modal>
      )}

      {showPrebuilt && (
        <Modal onClose={() => setShowPrebuilt(false)} title="📚 Pre-built Templates (Dental Clinic)">
          <div style={{ maxHeight: 500, overflowY: 'auto' }}>
            {PREBUILT.map(t => (
              <div key={t.name} style={{ border: '1px solid #e5e7eb', borderRadius: 6, padding: 12, marginBottom: 10 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                  <strong>{t.name}</strong>
                  <span style={{ fontSize: 11, color: '#666' }}>{t.category}</span>
                </div>
                <div style={{ fontSize: 13, background: '#f9fafb', padding: 8, borderRadius: 4, marginBottom: 6 }}>{t.body}</div>
                <div style={{ fontSize: 11, color: '#666', marginBottom: 6 }}>
                  Variables: {t.vars.map((v, i) => `{{${i + 1}}}=${v}`).join(', ')}
                </div>
                <button onClick={() => create(t)} style={{ ...btnPrimary, fontSize: 12, padding: '6px 12px' }}>Use this</button>
              </div>
            ))}
          </div>
        </Modal>
      )}
    </div>
  );
}

function Modal({ children, onClose, title }) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: 'white', borderRadius: 8, padding: 24, width: '90%', maxWidth: 600, maxHeight: '90vh', overflow: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
          <h3 style={{ margin: 0 }}>{title}</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer' }}>×</button>
        </div>
        {children}
      </div>
    </div>
  );
}

const input = { padding: 10, border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14, marginBottom: 10, width: '100%', boxSizing: 'border-box' };
const btnPrimary = { padding: '8px 16px', background: '#25D366', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 };
const btnSecondary = { padding: '8px 16px', background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 6, cursor: 'pointer' };
const card = { background: 'white', padding: 16, borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' };
